import { render, staticRenderFns } from "./commission-rules.vue?vue&type=template&id=e1162dd0&scoped=true"
import script from "./commission-rules.vue?vue&type=script&lang=js"
export * from "./commission-rules.vue?vue&type=script&lang=js"
import style0 from "./commission-rules.vue?vue&type=style&index=0&id=e1162dd0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1162dd0",
  null
  
)

export default component.exports